import {
  Button,
  Container,
} from '@mui/material';

import React, { FunctionComponent, } from 'react';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { push } from '@lagunovsky/redux-react-router';

import './NotFound.css';

interface Props {
}

const ErrorPage:FunctionComponent<Props> = ( props ) => {

  const { t } = useTranslation( [ 'notFound' ] );

  const dispatch = useDispatch<AppDispatch>();

  const onClick = () => {
    dispatch( push( '/') );
  }

  return (
    <AppLayout title={ t( 'error' ) }>
      <div className="page page-not-found">
        <Container sx={{ mt:4 }}>
          <h2>{ t( 'Page not found.' ) }</h2>
          <Button
            onClick={ onClick }
            variant='contained'
          >{ t( 'back' ) }</Button>
        </Container>
      </div>
    </AppLayout>
  );
}

export default ErrorPage;
